export default [
    {
		path: "/messages/list/:messageid?",
		component: () => import("../views/Messages/List.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/messages/new/:threadid?",
		component: () => import("../views/Messages/New.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/messages/seriousconcern",
		component: () => import("../views/Messages/SeriousConcern.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
